import { takeEvery } from 'redux-saga/effects';
import {
  FETCH_CUSTOMER_PORTFOLIO_ITEMS,
  FETCH_CUSTOMER_BUYING_STATS,
  FETCH_CUSTOMER_SELLING_STATS,
  FETCH_CUSTOMER_PORTFOLIO_ITEMS_SET,
} from './actions';
import {
  onFetchCustomerPortfolioItems,
  onFetchCustomerBuyingStats,
  onFetchCustomerSellingStats,
  onfetchCustomerPortfolioItemsSet,
} from './effects';

export function* fetchCustomerPortfolioItemsSaga() {
  yield takeEvery(
    // @ts-expect-error ts-migrate(2769) FIXME: No overload matches this call.
    FETCH_CUSTOMER_PORTFOLIO_ITEMS,
    onFetchCustomerPortfolioItems,
  );
}

export function* fetchCustomerBuyingStatsSaga() {
  // @ts-expect-error ts-migrate(2769) FIXME: No overload matches this call.
  yield takeEvery(FETCH_CUSTOMER_BUYING_STATS, onFetchCustomerBuyingStats);
}

export function* fetchCustomerSellingStatsSaga() {
  // @ts-expect-error ts-migrate(2769) FIXME: No overload matches this call.
  yield takeEvery(FETCH_CUSTOMER_SELLING_STATS, onFetchCustomerSellingStats);
}

export function* onfetchCustomerPortfolioItemsSetSaga() {
  yield takeEvery(
    // @ts-expect-error ts-migrate(2769) FIXME: No overload matches this call.
    FETCH_CUSTOMER_PORTFOLIO_ITEMS_SET,
    onfetchCustomerPortfolioItemsSet,
  );
}
